import { render, staticRenderFns } from "./PartnerBusinessSelect.vue?vue&type=template&id=2f72bd9a&scoped=true&"
import script from "./PartnerBusinessSelect.vue?vue&type=script&lang=js&"
export * from "./PartnerBusinessSelect.vue?vue&type=script&lang=js&"
import style0 from "./PartnerBusinessSelect.vue?vue&type=style&index=0&id=2f72bd9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72bd9a",
  null
  
)

export default component.exports